module.exports = __webpack_public_path__ + "img/default-product.99d45f91.png";